import { createEffect, createSignal, Show } from 'solid-js';

import socket from './socket';
import { dateTimeFieldsInParis, parisFieldsToIso } from './dateTime';

type Props = {
    problemKey: string;
    defaultValue: string | null;
    overrideValue: string | null;
    hasOverride: boolean;
    previousValue: string | null;
};

export default function ProblemStartingDate(props: Props) {
    const [date, setDate] = createSignal('');
    const [time, setTime] = createSignal('');
    const [error, setError] = createSignal('');

    createEffect(() => {
        const fields = dateTimeFieldsInParis(props.overrideValue || props.defaultValue);
        setDate(fields.date);
        setTime(fields.time);
        setError('');
    });

    const save = (nextDate = date(), nextTime = time()) => {
        const iso = parisFieldsToIso(nextDate, nextTime);
        if (!iso) {
            if (nextDate && nextTime) setError('Date ou heure invalide.');
            return;
        }
        setError('');
        socket.emit('set-problem-starting-date', {
            problemKey: props.problemKey,
            startingDateOverride: iso
        });
    };

    const copyPrevious = () => {
        const fields = dateTimeFieldsInParis(props.previousValue);
        setDate(fields.date);
        setTime(fields.time);
        save(fields.date, fields.time);
    };

    return <div class="starting-date-editor">
        <div class="d-flex flex-wrap gap-2 align-items-center">
            <input
                type="date"
                class="form-control form-control-sm starting-date-editor__date"
                aria-label="Date de début, heure de Paris"
                value={date()}
                onChange={(event) => {
                    setDate(event.currentTarget.value);
                    save(event.currentTarget.value, time());
                }}
            />
            <input
                type="time"
                class="form-control form-control-sm starting-date-editor__time"
                aria-label="Heure de début, heure de Paris"
                step="300"
                value={time()}
                onChange={(event) => {
                    setTime(event.currentTarget.value);
                    save(date(), event.currentTarget.value);
                }}
            />
            <Show when={props.previousValue}>
                <button
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    title="Utiliser la même date et la même heure que la ligne précédente"
                    onClick={copyPrevious}
                >↑ Même date</button>
            </Show>
            <Show when={props.hasOverride}>
                <button
                    type="button"
                    class="btn btn-link btn-sm p-0"
                    onClick={() => socket.emit('set-problem-starting-date', {
                        problemKey: props.problemKey,
                        startingDateOverride: null
                    })}
                >Réinitialiser</button>
            </Show>
        </div>
        <Show when={error()}><div class="small text-danger">{error()}</div></Show>
    </div>;
}
